import * as React from "react";

import { css } from "glamor";
import Steps from "./Steps";

const styles = {
	wrapper: css({
		display: "flex",
	}),
	leftSide: css({
		width: "70%",
	}),
	rightSide: css({
		width: "30%",
	}),
};

interface Props {
	steps: string[];
	currentIndex: number;
	dark: boolean;
}

export default class OverviewContainer extends React.Component<Props> {
	public render() {
		return (
			<div>
				<div {...styles.wrapper}>
					<div {...styles.leftSide}>{this.props.children}</div>
					<div {...styles.rightSide}>
						<Steps
							steps={this.props.steps}
							currentIndex={this.props.currentIndex}
							dark={this.props.dark}
						/>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/FightRoom/OverviewContainer.tsx